import React, { createContext, useContext, ReactNode } from "react";

interface SidebarContextType {
  sidebarWidth: number;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SIDEBAR_WIDTHS = {
  COLLAPSED: 40,
  EXPANDED: 190,
  // Affiliate shells only: the bottom account row carries the company name AND
  // the logged-in affiliate's email, which needs more room than the nav labels.
  // Widening the expanded state is free — the sidebar expands as an overlay, so
  // the reserved layout width stays COLLAPSED either way.
  EXPANDED_WITH_ACCOUNT: 240,
} as const;

/**
 * The sidebar is always collapsed as far as the layout is concerned: hovering
 * it expands it as an overlay ABOVE the content (see PlatformSidebar), so the
 * content margin/width never changes and `sidebarWidth` is a constant.
 */
export const SidebarProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <SidebarContext.Provider
      value={{ sidebarWidth: SIDEBAR_WIDTHS.COLLAPSED }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};
